import React from "react";
import { Card } from "antd";

export default function StatCard({
  icon,
  title,
  value,
  subtitle,
  iconBg = "bg-purple-100",
  iconColor = "text-purple-600",
  valueColor = "text-slate-900",
}) {
  return (
    <Card className="rounded-2xl shadow-sm h-full">
      <div className="flex items-center gap-4">
        <div
          className={`w-14 h-14 rounded-full ${iconBg} ${iconColor} flex items-center justify-center shrink-0`}
        >
          {icon}
        </div>

        <div>
          <p className="text-slate-500 text-sm m-0">{title}</p>

          <h2 className={`text-3xl font-bold my-1 ${valueColor}`}>
            {value}
          </h2>

          {subtitle && (
            <p className="text-slate-400 text-xs m-0">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </Card>
  );
}